import styles from "./articleListingPanel.module.scss"
import DynamicCard from "../../../components/dynamicCard/dynamicCard";
function Col3LSM({articles}){
    return articles.map((chunk, idx)=>{
        return (
            <div className={`${styles.col} col-${idx + 1}`}>
                {chunk["chunk"].map((a, jdx)=>{
                  var layout = "vertical";
                  var oneline = false;
                  var summary = a.summary;
                  var dimensions = {
                    width: 368,
                    height: 206
                  }
                  if(idx === 0 && jdx === 0){
                    oneline = true;
                    dimensions.width = 466;
                    dimensions.height = 260;
                  }
                  if(idx === 0 && jdx === 1){
                    layout = "inline";
                    dimensions.width = 177;
                    dimensions.height = 99
                  }
                  if(idx === 1){
                    summary = null;
                    dimensions.width = 270;
                    dimensions.height = 151;
                  }
                  if(idx === 2 && jdx === 1){
                    layout = "modified";
                  }
                    return (
                      <div className={`${styles.articleCard} articleCard`}>
                        <DynamicCard
                          headline={a.content.headline ? a.content.headline : null}
                          thumbnail={a.content.thumbnail ? a.content.thumbnail : null}
                          date={a.content.created_at ?? null}
                          summary={summary ? summary : null}
                          tags={a.tags ? a.tags: null}
                          category={a.content.category ? a.content.category: null}
                          type={a.content.article_type ? a.content.article_type: null}
                          author={a.content.authors ? a.content.authors: null}
                          layout={layout}
                          oneline={oneline}
                          dimensions={dimensions}
                        />
                        </div> 
                    );
                })}
            </div>
        )
    })
}

export default Col3LSM;
